module.exports = __webpack_public_path__ + "img/cbl1.814cc373.gif";